<script setup>
import { ref } from 'vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';

const form = useForm({
  password: '',
});

const passwordInput = ref(null);

const submit = () => {
  form.post(route('password.confirm'), {
    onFinish: () => {
      form.reset();

      passwordInput.value.focus();
    },
  });
};
</script>

<template>
  <Head title="Secure Area" />

  <JetAuthenticationCard>
    <template #logo>
      <div v-if="$settings.login_logo_url" class="my-2 w-80 max-w-full mx-auto flex items-end justify-center">
        <img :src="$settings.login_logo_url" :alt="$settings.name" class="max-h-full max-w-full rounded object-cover" />
      </div>
      <JetAuthenticationCardLogo v-else />
    </template>

    <div class="mb-4 text-sm text-gray-600">This is a secure area of the application. Please confirm your password before continuing.</div>

    <JetValidationErrors class="mb-4" />

    <form @submit.prevent="submit">
      <div>
        <JetLabel for="password" value="Password" />
        <JetInput
          id="password"
          ref="passwordInput"
          v-model="form.password"
          type="password"
          class="mt-1 block w-full"
          required
          autocomplete="current-password"
          autofocus
        />
      </div>

      <div class="flex justify-end mt-4">
        <JetButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing"> Confirm </JetButton>
      </div>
    </form>
  </JetAuthenticationCard>
</template>
